import { useCallback, useRef } from "react";

import { useForceRerender } from "hooks";
import { FieldValues, UseFormReturn } from "react-hook-form";

export const useFormContainer = <V extends FieldValues>() => {
  const forceRender = useForceRerender();
  const registered = useRef(false);
  const ref = useRef<UseFormReturn<V>>({} as UseFormReturn<V>);

  const formRegister = useCallback((methods: typeof ref.current) => {
    registered.current = true;
    Object.assign(ref.current, methods);
    forceRender();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...ref.current,
    isRegistered: registered.current,
    formRegister,
  };
};
